import BaseModel from '../../../models/base';

const AUTOCOMPLETE_MINIMUM = 1;
const SEARCH_MINIMUM = 1;

const QuickSearchModel = BaseModel.extend({

    defaults() {
        return {
            text: ''
        };
    },

    isValidForAutocomplete() {
        return this.get('text').length >= AUTOCOMPLETE_MINIMUM;
    },

    isValidForSearch() {
        return this.get('text').length >= SEARCH_MINIMUM;
    }

});

export default QuickSearchModel;
